SP.ProductTile = Garnish.Base.extend({
    $el: null,

    $quickViewBtn: null,
    $quickViewBtnBundle: null,

    init(el) {
        this.$el = $(el)
        this.$quickViewBtn = this.$el.find('.quick-view-btn')
        this.$quickViewBtnBundle = this.$el.find('.quick-view-bundle-btn')

        // Setup variant switcher
        this.variantSwitcher()


        // Quickview for regular product tiles
        if (this.$quickViewBtn.length > 0) {
            this.addListener(this.$quickViewBtn, 'click', this.handleQuickView)
        }

        // Quickview for bundle product tiles
        if (this.$quickViewBtnBundle.length > 0) {
            this.addListener(this.$quickViewBtnBundle, 'click', this.handleQuickViewBundle)
        }

        this.addListener(this.$el, 'mouseenter', this.handleMouseEnter)
        this.addListener(this.$el, 'mouseleave', this.handleMouseLeave)
    },

    handleMouseEnter() {
        let self = this

        let productTypeLink = this.$el.find('.product-type-link')
        this.$el.addClass('show-shop-link')

        productTypeLink.mouseenter(function() {
            self.$el.addClass('hide-shop-link')
        }).mouseleave(function() {
            self.$el.removeClass('hide-shop-link')
        })
    },

    handleMouseLeave() {
        this.$el.removeClass('show-shop-link')
        this.$el.removeClass('hide-shop-link')
        this.$el.removeClass('show-lifestyle-image')
    },

    variantSwitcher() {
        let variantImageSwitches = this.$el.find('[data-variant-image-switcher]')
        if (variantImageSwitches) {
            $.each(variantImageSwitches, function (index, el) {
                new SP.VariantImageSwitcher(el)
            })
        }
    },

    handleQuickView() {
        new SP.ProductQuickview(this.$quickViewBtn, this)
    },

    handleQuickViewBundle() {
        new SP.ProductQuickviewBundle(this.$quickViewBtn, this)
    }
})
